module.exports = __webpack_public_path__ + "img/shipping.6ac1fd2e.svg";